import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";

export default function ActivityLog() {
  const [items, setItems] = useState([]);
  const [entityType, setEntityType] = useState("all");

  const load = () => {
    const qs = entityType === "all" ? "" : `?entity_type=${entityType}`;
    api.get(`/activity${qs}`).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  };
  useEffect(() => { load(); }, [entityType]);

  return (
    <div data-testid="activity-page" className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-[#1B2A4A]">Activity Log</h1>
          <p className="text-sm text-[#475569] mt-1">Who entered or edited what, and when</p>
        </div>
        <Select value={entityType} onValueChange={setEntityType}>
          <SelectTrigger data-testid="activity-type-filter" className="w-52 bg-white"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">
            <SelectItem value="all">All activity</SelectItem>
            <SelectItem value="listing">Listings</SelectItem>
            <SelectItem value="category">Categories</SelectItem>
            <SelectItem value="category_request">Category Requests</SelectItem>
            <SelectItem value="document">Documents</SelectItem>
            <SelectItem value="employee">Employees</SelectItem>
            <SelectItem value="city">Cities</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="bg-white border border-[#E2E8F0] rounded-xl overflow-hidden">
        <table className="w-full text-sm" data-testid="activity-table">
          <thead>
            <tr className="border-b border-[#E2E8F0] bg-[#F5F7FA] text-left">
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">When</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">Employee</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">Action</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">Entity</th>
              <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#94A3B8]">Detail</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center text-[#94A3B8]" data-testid="activity-empty">No activity recorded yet.</td></tr>
            )}
            {items.map((a) => (
              <tr key={a.id} data-testid={`activity-row-${a.id}`} className="border-b border-[#F1F5F9]">
                <td className="px-4 py-3 text-[#475569] whitespace-nowrap">{new Date(a.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 font-medium text-[#0F172A]">{a.user_name}</td>
                <td className="px-4 py-3">
                  <span className="text-xs font-semibold px-2.5 py-0.5 rounded-full border text-[#1D4ED8] bg-[#DBEAFE] border-[#BFDBFE]">{a.action}</span>
                </td>
                <td className="px-4 py-3 text-[#475569]">{a.entity_type}{a.entity_name ? ` — ` : ""}<span className="font-medium text-[#1B2A4A]">{a.entity_name}</span></td>
                <td className="px-4 py-3 text-[#94A3B8]">{a.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
